import { EmailTemplateComponent } from 'components/email-layout/templates/components'

import { RexDemonstration } from 'components/rex/demonstration/component'
import { RexWebinar } from 'components/rex/webinar/component'
import { RexCampaigns } from 'components/rex/campaigns/component'

import { PanelBarOption } from 'components/panel-bar/types'
import { WidgetsChrome } from 'components/widgets/chrome-ext'
import { WidgetsRss } from 'components/widgets/rss'
import { WidgetsSignup } from 'components/widgets/signup/component'
import { WidgetsTopArticles } from 'components/widgets/top-articles/component'
import { WidgetsTopicPreferences } from 'components/widgets/topic-preferences/component'
import { WidgetsSurveyResults } from 'components/widgets/survey-results/component'
import { WidgetsUnsubscribe } from 'components/widgets/unsubscribe/component'
import { WidgetsViewInBrowser } from 'components/widgets/viewInBrowser'

const forms  = 'Forms'
const tools =  'Tools'
const trexTools = 'T-Rex Tools'
export const allSections: PanelBarOption[] = [
  {
    category: forms,
    component: WidgetsSignup,
    isMenu: true,
    name: 'Subscribe',
    route: '',
  },
  {
    category: forms,
    component: WidgetsUnsubscribe,
    isMenu: true,
    name: 'Unsubscribe',
    route: 'unsubscribe',
  },
  {
    category: forms,
    component: WidgetsTopArticles,
    isMenu: true,
    name: 'Top Articles Subscribe',
    route: 'toparticles',
  },
  {
    category: forms,
    component: WidgetsTopicPreferences,
    isMenu: true,
    name: 'Topic Preferences',
    route: 'topic-preferences',
  },
  {
    category: forms,
    component: WidgetsSurveyResults,
    isMenu: true,
    name: 'Survey Results',
    route: 'survey-results',
  },
  {
    category: tools,
    component: WidgetsRss,
    isMenu: true,
    name: 'Top Articles RSS Feed',
    route: 'rss',
  },
  {
    category: tools,
    component: WidgetsViewInBrowser,
    isMenu: true,
    name: 'View In Browser',
    route: 'viewinbrowser',
  },
  {
    category: tools,
    component: WidgetsChrome,
    isMenu: true,
    name: 'Chrome extension',
    route: 'chrome-ext',
  },
  {
    category: tools,
    component: EmailTemplateComponent,
    isMenu: true,
    name: 'Custom Email Templates',
    route: 'templates',
  },
  {
    category: trexTools,
    component: RexDemonstration,
    isMenu: true,
    name: 'Rex Demonstration',
    route: 'rex',
    superUserOnly: true,
  },
  {
    category: trexTools,
    component: RexWebinar,
    isMenu: true,
    name: 'Rex Webinar',
    route: 'rex/webinar',
    superUserOnly: true,
  },
  {
    category: trexTools,
    component: RexCampaigns,
    isMenu: true,
    name: 'Campaigns',
    route: 'rex/campaigns',
    superUserOnly: true,
  },
]

export const sections = (isSuperAdmin: boolean, hasSurveyAccess: boolean = true) => {
  const availableSections = allSections.filter((item) => {
    if (item.name === 'Template Codes') {
      return isSuperAdmin
    } else if (item.superUserOnly) {
      return isSuperAdmin
    } else if (item.name === 'Survey Results') {
      return hasSurveyAccess
    } else {
      return true
    }
  })
  return availableSections
}
